import { Action } from 'vuex'
import { RootState } from '@/store/types'
import { MediaLibraryState } from '../types'
import { MediaLibraryParams } from '@/types/mediaLibrary'
import SiriusAPI from '@/api'
import nestedFreeze from '@/helpers/nestedFreeze'

const fetchImagesMediaLibrary: Action<MediaLibraryState, RootState> = async (
  { state, commit },
  payload: MediaLibraryParams
) => {
  try {
    commit('setLoading', { essence: payload.essence, loading: true })

    const { items } = await SiriusAPI.mediaLibrary.fetchMediaLibrary({
      essence: payload.essence,
      essenceId: payload.essenceId,
      page: payload.page,
      count: payload.count,
    })

    if (!state.value.has(payload.essence)) {
      return
    }

    commit('setImagesMediaLibrary', {
      essence: payload.essence,
      images: nestedFreeze(items),
    })
    commit('setHasMore', {
      essence: payload.essence,
      hasMore: items.length > 0,
    })
  } catch (error) {
    console.error(error)
  } finally {
    commit('setLoading', { essence: payload.essence, loading: false })
  }
}

export default fetchImagesMediaLibrary
